import { resolveObjectOutline } from './object'
import { refKey, refsKey as refsIdentity } from './refs'

export { anchorsOf, cornersToPath, isSimpleOutline, segmentChord } from './path'
export { normalizeRef, REF_DEFAULTS, refKey } from './refs'

// cyrb53: a 53-bit string hash, so a key stays short whatever the path's length.
const hash = s => {
	let h1 = 0xdeadbeef
	let h2 = 0x41c6ce57
	for (let i = 0; i < s.length; i++) {
		const c = s.charCodeAt(i)
		h1 = Math.imul(h1 ^ c, 2654435761)
		h2 = Math.imul(h2 ^ c, 1597334677)
	}
	h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909)
	h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909)
	return (2097152 * (h2 >>> 0) + (h1 >>> 0)).toString(36)
}

/** A key over the geometry alone: two providers with the same `d` share it, and so share a baked field. */
export const outlineKey = d => `${hash(d)}.${d.length}`

const outline = (d, anchors) => ({ d, key: outlineKey(d), anchors, segments: anchors.length })

export const resolveOutline = (ref, env) => (ref ? resolveObjectOutline(ref.id, env?.objects, outline) : null)

/**
 * A reference list's identity, blind to property order and to defaults spelled out or left absent. With `env` (as for `resolveOutline`), each reference also carries its outline's `key` (`-` when it resolves to nothing): two lists naming the same providers differ when a provider's geometry does, as when a fade's two presets hold one shape id with different `data`.
 * The key is geometry and world-scale bucket only, never the pose (`transform`), so a pose-only change keeps the list's identity (DECISIONS 2026-10-07 local space).
 */
export const refsKey = (refs, env) =>
	env === undefined
		? refsIdentity(refs)
		: (refs ?? []).map(r => `${refKey(r)}@${resolveOutline(r, env)?.key ?? '-'}`).join('|')
